import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Container,
  Flex,
  Text,
  Icon,
  GridItem,
  useTheme,
} from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';

import Link from '@rsc/ui-components/tailwind/Link';
import { DeptGrid } from '../../../design-system';

const handleThemeColors = (theme, colors) => {
  let bgColor = colors?.transparent;
  let txtColor = colors?.neutral[900];
  let cirColor = colors?.sunny[500];
  let arrowColor = colors?.neutral[900];

  if (theme === 'Sunny') {
    bgColor = colors?.sunny[500];
    txtColor = colors?.neutral[900];
    cirColor = colors?.brand?.ink;
    arrowColor = colors?.sunny[500];
  }

  if (theme === 'Light') {
    bgColor = colors?.primary?.light;
    txtColor = colors?.neutral[900];
    cirColor = colors?.brand?.ink;
    arrowColor = colors?.primary?.light;
  }

  if (theme === 'Base') {
    bgColor = colors?.primary?.base;
    txtColor = colors?.background;
  }

  if (theme === 'Dark') {
    bgColor = colors?.primary?.dark;
    txtColor = colors?.background;
  }

  if (theme === 'Extra Dark') {
    bgColor = colors?.button?.ink;
    txtColor = colors?.background;
  }

  return {
    bgColor,
    txtColor,
    cirColor,
    arrowColor,
  };
};

export default function ThinBanner({ block }) {
  const { colors } = useTheme();
  const { bgColor, txtColor, cirColor, arrowColor } = handleThemeColors(
    block?.theme,
    colors
  );

  return (
    <Box my="14" bg={bgColor}>
      <Container>
        <Flex py="6" px={{ base: '6', md: '10', lg: '20' }}>
          <DeptGrid content="flex-end" direction="column" w="full">
            <GridItem colSpan={{ base: '12', md: '4', lg: '8' }}>
              <Text
                as="h2"
                color={txtColor}
                textStyle="h3"
                fontSize="lg"
                fontWeight="black"
              >
                {block?.headline}
              </Text>
              {block?.subHead && <Text color={txtColor}>{block?.subHead}</Text>}
            </GridItem>
            {block?.cta && (
              <GridItem
                as={Flex}
                colSpan={{ base: '12', md: '2', lg: '4' }}
                align="flex-end"
                direction="column"
                justify="center"
              >
                <Flex
                  as={Link}
                  className="flex items-center justify-center gap-3"
                  link={block?.cta?.link}
                  role="group"
                >
                  <Text
                    textStyle="h3"
                    fontSize="md"
                    fontWeight="black"
                    color={txtColor}
                    _groupHover={{
                      textDecorationThickness: 'inherit',
                      textDecorationColor: txtColor,
                      textDecorationLine: 'underline',
                    }}
                  >
                    {block?.cta?.text}
                  </Text>
                  <Flex
                    bg={cirColor}
                    w="10"
                    h="10"
                    align="center"
                    justify="center"
                    borderRadius="50%"
                    shrink="0"
                  >
                    <Icon as={MdArrowForward} boxSize={6} color={arrowColor} />
                  </Flex>
                </Flex>
              </GridItem>
            )}
          </DeptGrid>
        </Flex>
      </Container>
    </Box>
  );
}

ThinBanner.propTypes = {
  block: PropTypes.shape({
    theme: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    subHead: PropTypes.string,
    themeObj: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string,
      link: PropTypes.shape({}),
    }),
  }).isRequired,
};
